import { SESSION } from "../types/actions";
import { get } from "lodash";

export default (state = { userType: "P", isAdmin: false }, action) => {
	switch (action.type) {
		case SESSION.SEND_LOGIN_CREDENTIALS:
			return {
				...state,
				userDetails: action.payload
			};
		case SESSION.UPDATE_LOGIN_CREDENTIALS:
			return {
				...state,
				userDetails: action.payload,
				userType: get(action, "payload.user.user_type", "P"),
				isAdmin: get(action, "payload.user.user_type", "P") === "A" ? true : false
			};
		default:
			return state;
	}
};
